import { useEffect, useState } from 'react';
import axios from '../../../lib/axios';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { numberFormat } from '../../../utils/nunberFormat';
import { BannerModel } from '../../../models/banner';
import { BannerEnum } from '../../../enums/bannerEnum';
import { StatusEnum } from '../../../enums/status';
import { BANNER_URL } from '../../../lib/endpoints/advertise';
import { getAllBannerPromotionAndCouponService, getAllBannerSlideService } from '../../../services/banner';
import { getMerchantData } from '../../../services/merchant';
import { MerChantModel } from '../../../models/merChantModel';
import { getAllTagPromotion } from '../../../services/tagPromotion';
import { TagPromotionModel } from '../../../models/tagPromotion.model';

export const useBannerController = () => {

  const [data, setData] = useState<BannerModel[]>([]);
  const [merchantData, setMerchantData] = useState<MerChantModel[]>([])
  const [tagPromotionData, setTagPromotionData] = useState<TagPromotionModel[]>([])
  const [tabBannerType, setTabBannerType] = useState<BannerEnum>(BannerEnum.LANDING_PAGE);
  const [tabStatus, setTabStatus] = useState<StatusEnum>(StatusEnum.ALL);

  const [selectedId, setSelectedId] = useState<string>('');
  const [selectedData, setSelectedData] = useState<BannerModel>(null!);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  
  // functions

  const handleDeleteData = async () => {
    try {
      setLoadingDelete(true);
      const url: string =
        tabBannerType === BannerEnum.COUPON
          ? '/advertise/banner-promotion-and-coupon/delete-coupon'
          : tabBannerType === BannerEnum.PROMOTION
            ? '/advertise/banner-promotion-and-coupon/delete-promotion'
            : '/advertise/banner/delete';
      await axios.delete(BANNER_URL + `${url}?id=${selectedId}`);
      setData(data?.filter((item) => item?.id !== selectedId));
      setOpenDeleteDialog(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleGetData = async () => {
    try {
      setLoading(true)
      handleFetchData(tabBannerType)
      const resMerchant = await getMerchantData()
      const resTagPro = await getAllTagPromotion()
      setTagPromotionData(resTagPro)
      setMerchantData(resMerchant)
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchData = async (bannerType: BannerEnum) => {
    try {
      let resBannerSlide;
      if (bannerType === BannerEnum.COUPON || bannerType === BannerEnum.PROMOTION) {
        const resBannerProAndCoupon = await getAllBannerPromotionAndCouponService({ limit: 100 });
        resBannerSlide = resBannerProAndCoupon;
      } else {
        resBannerSlide = await getAllBannerSlideService({ limit: 100 });
      }
      setData(resBannerSlide);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  }

  const handleBannerTypeChange = async (newValue: BannerEnum) => {
    setTabBannerType(newValue)
    await handleFetchData(newValue)
  }

  const handleOpenForm = () => {
    setOpenForm(true);
    setSelectedData(null!);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
    setSelectedData(null!);
  };

  const handleClickDeleteButton = () => {
    setOpenMenu(null);
    setOpenDeleteDialog(true);
  };

  const handleClickEditButton = () => {
    setOpenMenu(null);
    setOpenForm(true);
    if (selectedId) {
      setSelectedData(data?.filter((item) => item?.id === selectedId)[0]);
    }
  };

  const onOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const onCloseMenu = () => {setOpenMenu(null)};

  // ----------------------------------------------

  const filterDataByStatus: BannerModel[] = data?.filter((item: BannerModel) =>
    tabStatus === StatusEnum.ALL
      ? true
      : tabStatus === StatusEnum.ACTIVE
        ? item?.isActive === true : item?.isActive === false 
  );

  const filterData: BannerModel[] = filterDataByStatus?.filter((item: BannerModel) => item?.type === tabBannerType);
  const countPagination = Math.ceil(filterData?.length / DEFAULT_ROWS_PER_PAGE);
  const rows: BannerModel[] = filterData?.slice((currentPage - 1) * DEFAULT_ROWS_PER_PAGE, currentPage * DEFAULT_ROWS_PER_PAGE + DEFAULT_ROWS_PER_PAGE);

  // useEffect
  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    rows,
    loading,
    openMenu,
    openForm,
    currentPage,
    tabStatus,
    merchantData,
    tabBannerType,
    countPagination,
    tagPromotionData,
    loadingDelete,
    openDeleteDialog,
    selectedData,
    handleOpenForm,
    handleCloseForm,
    onOpenMenu,
    onCloseMenu,
    handleBannerTypeChange,
    handleGetData,
    handleDeleteData,
    handleClickDeleteButton,
    handleClickEditButton,
    handlePageChange: (event: any, newPage: any) => setCurrentPage(newPage),
    handleSetOpenDeleteDialog: (newValue: boolean) => setOpenDeleteDialog(newValue),
    handleCountIndex: (index: number) => numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (currentPage - 1)),
    handleSetTabStatus: (newValue: StatusEnum) => {
      setTabStatus(newValue);
      setCurrentPage(1);
    },

  };
};
